export default __webpack_public_path__ + "static/media/frango-screenshot-03.459bc575.png";